export default __webpack_public_path__ + "static/media/user2.6bcfda49.png";